export const ADMIN_USERS_QUERY_KEY = ['admin', 'users']

export const ADMINISTRATOR_KEY = 'isAdministrator'

const NON_PRODUCTION_HINT = 'Fora de Produção é sempre liberado.'

export const PERMISSION_GROUPS = [
  {
    title: 'Clientes',
    permissions: [
      {
        key: 'allowedToGenerateJwt',
        label: 'Login administrativo (JWT)',
        hint: `Menu Login Administrativo, resetar 2FA e forçar backup completo. ${NON_PRODUCTION_HINT}`,
      },
      {
        key: 'allowedToLoadBackup',
        label: 'Histórico de backups',
        hint: 'Exibe o histórico na aba Backup de Clientes.',
      },
      {
        key: 'allowedToResetElastic',
        label: 'Resetar Elasticsearch',
        hint: 'Ação de reindexação do tenant em Clientes.',
      },
      {
        key: 'allowedToManageSubscriptions',
        label: 'Gerenciar assinaturas',
        hint: 'Alterar plano e assinatura do cliente.',
      },
    ],
  },
  {
    title: 'Ações comerciais',
    permissions: [
      {
        key: 'allowedToManageBanner',
        label: 'Banner Login',
        hint: 'Menu Ações Comerciais › Banner Login.',
      },
      {
        key: 'allowedToApplyCouponToATenant',
        label: 'Aplicar cupom a um tenant',
        hint: 'Aplicar cupom de desconto direto em um cliente.',
      },
      {
        key: 'allowedToGenerateAutomaticCoupons',
        label: 'Cupons automáticos e turbos',
        hint: `Aba Automáticos em Cupom de desconto. ${NON_PRODUCTION_HINT}`,
      },
      {
        key: 'allowedToGenerateAmbassadorCoupons',
        label: 'Embaixadores',
        hint: `Aba Embaixadores em Cupom de desconto. ${NON_PRODUCTION_HINT}`,
      },
    ],
  },
  {
    title: 'Operações',
    permissions: [
      {
        key: 'allowedToLogoutUsers',
        label: 'Logout de usuários',
        hint: 'Derrubar sessões de usuários do Astrea.',
      },
      { key: 'allowedToUseRobots', label: 'Robôs', hint: 'Menu Robôs.' },
      {
        key: 'allowedToManageFeature',
        label: 'Administrar Feature Toggles',
        hint: 'Criar e editar toggles em Feature Toggle › Admin.',
      },
    ],
  },
]

export const PERMISSIONS = PERMISSION_GROUPS.flatMap((group) => group.permissions)

export const PERMISSION_KEYS = PERMISSIONS.map((permission) => permission.key)

export const ROLE_FILTERS = {
  ALL: 'all',
  SUPER_ADMINISTRATORS: 'superAdministrators',
  ADMINISTRATORS: 'administrators',
  SUPPORT: 'support',
}

export const ROLE_FILTER_OPTIONS = [
  { value: ROLE_FILTERS.ALL, label: 'Todos' },
  { value: ROLE_FILTERS.SUPER_ADMINISTRATORS, label: 'Administradores gerais' },
  { value: ROLE_FILTERS.ADMINISTRATORS, label: 'Administradores' },
  { value: ROLE_FILTERS.SUPPORT, label: 'Suporte' },
]

export const USER_ROLES = {
  SUPER_ADMINISTRATOR: 'superAdministrator',
  ADMINISTRATOR: 'administrator',
  SUPPORT: 'support',
}

export const SUMMARY_VISIBLE_PERMISSIONS = 3
